export const revisionHoldGerman = {
  remove: 'Importmeldung löschen',
  removeTitle: 'Diese Importmeldung entfernen?',
  removeDescription:
    'Es wird keine Buchung geändert oder storniert. Die Kalenderverfügbarkeit bleibt unverändert.',
  removeSelected: 'Entfernt wird nur diese Meldung, auch bei mehreren Meldungen derselben Buchung.',
  removed: 'Importmeldung entfernt.',
  removeUnknown:
    'Keine Antwort vom Server – ob die Importmeldung entfernt wurde, ist offen. Die Liste wird neu geladen.',
  removeFailed: 'Die Importmeldung konnte nicht entfernt werden.',
  cancel: 'Abbrechen',
  empty: 'Keine offenen Importmeldungen',
  emptyDescription: 'Neue Importmeldungen stehen hier mit ihrem Verarbeitungsstand und Grund.',
  description:
    'Offene Meldungen aus Buchungsportalen: noch fehlende Buchungen und nicht angewendete Änderungen bestehender Buchungen.',
  intro:
    'Jede Meldung betrifft genau eine Revision. Eine Änderung kann abgewiesen sein, obwohl die Buchung bereits vorhanden ist.',
  availabilitySeparate:
    'Das Entfernen einer Importmeldung ändert keine Verfügbarkeit. Das erneute Senden der Kalenderverfügbarkeit ist eine separate Aktion.',
  existingChange:
    'Nicht angewendete Änderung einer bestehenden Buchung. Der bisherige Buchungsstand bleibt erhalten.',
  missingBooking: 'Für diese Meldung ist noch keine Buchung übernommen.',
  rederive: 'Verfügbarkeit erneut an Buchungsportale senden',
  previewTitle: 'Kalenderverfügbarkeit erneut senden?',
  previewDescription:
    'Die Verfügbarkeit wird aus bestehenden Buchungen und Kalendersperren neu abgeleitet und zur Übertragung eingereiht.',
  previewScope: 'Objekt, sichtbare Apartments und betroffene Nächte',
  nights: '{{from}} bis {{to}} · Abreisetag ausgeschlossen',
  previewWarning:
    'Prüfe den Buchungsstand im Portal. Eine nicht übernommene Kanalbuchung kann dort weiterhin aktiv sein.',
  previewNoRemoval:
    'Die Importmeldung bleibt bestehen. Eingereihte Übertragungen sind noch keine Bestätigung der Buchungsportale.',
  previewLoading: 'Umfang wird geladen …',
  previewFailed: 'Der Umfang konnte nicht geladen werden. Vor dem Senden erneut prüfen.',
  previewChanged:
    'Die Meldung, das Objekt oder die Apartments haben sich geändert. Prüfe die neu geladene Vorschau.',
  previewUnknown:
    'Keine Antwort vom Server – ob die Übertragung eingereiht wurde, ist offen. Der Dialog bleibt zur Prüfung geöffnet.',
  queued:
    '{{count}} Übertragungen eingereiht. Eine Bestätigung der Buchungsportale steht noch aus.',
  noWork:
    'Keine Übertragung eingereiht. Die betroffenen Apartments nehmen keine Verfügbarkeitsaufträge an.',
  retry: 'Erneut prüfen',
};

export const revisionHoldEnglish = {
  remove: 'Delete import notice',
  removeTitle: 'Remove this import notice?',
  removeDescription:
    'No booking will be changed or cancelled. Calendar availability stays unchanged.',
  removeSelected:
    'Only this notice will be removed, even when several notices belong to the same booking.',
  removed: 'Import notice removed.',
  removeUnknown:
    'No server response – whether the import notice was removed is unknown. Refreshing the list.',
  removeFailed: 'The import notice could not be removed.',
  cancel: 'Cancel',
  empty: 'No open import notices',
  emptyDescription: 'New import notices appear here with their processing status and reason.',
  description:
    'Open channel notices: bookings not yet imported and unapplied changes to existing bookings.',
  intro:
    'Each notice concerns exactly one revision. A change can be rejected while the booking already exists.',
  availabilitySeparate:
    'Removing an import notice does not change availability. Resending calendar availability is a separate action.',
  existingChange: 'Unapplied change to an existing booking. Its previous state remains unchanged.',
  missingBooking: 'No booking has been imported for this notice yet.',
  rederive: 'Resend availability to booking channels',
  previewTitle: 'Resend calendar availability?',
  previewDescription:
    'Availability will be derived from existing bookings and calendar blocks, then queued for transmission.',
  previewScope: 'Property, visible apartments and affected nights',
  nights: '{{from}} to {{to}} · departure day excluded',
  previewWarning:
    'Check the booking in the channel. A channel booking that was not imported may still be active there.',
  previewNoRemoval:
    'The import notice stays open. Queued transmissions do not confirm receipt by booking channels.',
  previewLoading: 'Loading affected scope …',
  previewFailed: 'Could not load the scope. Review it again before sending.',
  previewChanged: 'The notice, property or apartments changed. Review the refreshed preview.',
  previewUnknown:
    'No server response – whether the transmission was queued is unknown. The dialog stays open for review.',
  queued: '{{count}} transmissions queued. Confirmation from booking channels is still pending.',
  noWork: 'No transmission queued. The affected apartments do not accept availability operations.',
  retry: 'Review again',
};
